import {
  createRecapInfoFrenchApfp,
  refreshRecapInfoFrenchApfp,
  createNewRecapCostLineFrenchApfp,
  createRecapInfoCostLineIdsAndLabelsFrenchApfp,
} from '@src/utils/recapGridUtils/createQuoteRecapInfoUtil/createQuoteRecapInfoUtilFrenchApfpAndPostProd'

import {
  createRecapInfoAicp,
  refreshRecapInfoAicp,
  createNewRecapCostLineAicp,
  createRecapInfoCostLineIdsAndLabelsAicp,
} from '@src/utils/recapGridUtils/createQuoteRecapInfoUtil/createQuoteRecapInfoUtilAicp'

function getCreateQuoteRecapInfoUtil(quoteType: string) {
  switch (quoteType) {
    case 'frenchApfp':
      return {
        createRecapInfo: createRecapInfoFrenchApfp,
        refreshRecapInfo: refreshRecapInfoFrenchApfp,
        createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
        createRecapInfoCostLineIdsAndLabels: createRecapInfoCostLineIdsAndLabelsFrenchApfp,
      }
    case 'frenchPostProd':
      return {
        createRecapInfo: createRecapInfoFrenchApfp,
        refreshRecapInfo: refreshRecapInfoFrenchApfp,
        createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
        createRecapInfoCostLineIdsAndLabels: createRecapInfoCostLineIdsAndLabelsFrenchApfp,
      }
    case 'aicp':
      return {
        createRecapInfo: createRecapInfoAicp,
        refreshRecapInfo: refreshRecapInfoAicp,
        createNewRecapCostLine: createNewRecapCostLineAicp,
        createRecapInfoCostLineIdsAndLabels: createRecapInfoCostLineIdsAndLabelsAicp,
      }
    default:
      // By default return apfp
      return {
        createRecapInfo: createRecapInfoFrenchApfp,
        refreshRecapInfo: refreshRecapInfoFrenchApfp,
        createNewRecapCostLine: createNewRecapCostLineFrenchApfp,
        createRecapInfoCostLineIdsAndLabels: createRecapInfoCostLineIdsAndLabelsFrenchApfp,
      }
  }
}

export { getCreateQuoteRecapInfoUtil }
